import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';
import type { MailRole } from '../lib/supabase';
import { roleLabel } from '../lib/format';
import { istRedaktion } from '../lib/rollen';

interface Props {
  /** Rollen, die den Bereich sehen dürfen. */
  roles?: MailRole[];
  /** Statt Rollen: nur die Redaktion (Admins und Freigaberecht). */
  redaktion?: boolean;
  children: React.ReactNode;
}

/** Blendet Bereiche aus, die zur eigenen Rolle nicht passen — die Datenbank prüft ohnehin selbst. */
export function RequireRole({ roles, redaktion, children }: Props) {
  const { user } = useAuthStore();
  if (!user) return null;
  const erlaubt = redaktion ? istRedaktion(user) : !!roles?.includes(user.role);
  if (!erlaubt) {
    return (
      <div className="empty-state">
        <Shield size={48} aria-hidden="true" />
        <h3>Dieser Bereich ist für Deine Rolle nicht freigeschaltet</h3>
        <p>
          {redaktion
            ? 'Hier entscheidet die Redaktion: Admins und wer das Freigaberecht hat.'
            : <>Zugang haben: <strong>{roles?.map(roleLabel).join(', ')}</strong>. Deine Rolle: <strong>{roleLabel(user.role)}</strong>.</>}
        </p>
        <div style={{ marginTop: '1rem' }}><Link to="/" className="btn btn-secondary">Zur Startseite</Link></div>
      </div>
    );
  }
  return <>{children}</>;
}
